/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class PackageResumeModel {

  constructor(shipmentBaseUuid: string, maxDimension: string, sumVolume: string, pcsNr: string, sumWeight: string) {
    this.shipmentBaseUuid = shipmentBaseUuid;
    this.maxDimension = maxDimension;
    this.sumVolume = sumVolume;
    this.pcsNr = pcsNr;
    this.sumWeight = sumWeight;
  }

  shipmentBaseUuid: string | undefined = undefined;

  maxDimension: string | undefined = undefined;

  sumVolume: string | undefined = undefined;

  pcsNr: string | undefined = undefined;

  sumWeight: string | undefined = undefined;
}

